<script>
import { mapState } from "vuex";
import {EventBus} from "../../eventBus.js";
export default {
	props: {
		logoCliente: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			isHidden: true,
			user_data: this.$ls.get("user"),
		};
	},
	computed: {
		...mapState("MenuModule", ["listMenuIntranet", "menuCliente"]),
	},
	created() {
		EventBus.$on("updateUser", this.updateUser);
	},
	methods: {
		checkUserStoragePrivilegio() {
			if (this.user_data) {
				return (this.user_data.privilegio[0].id_tipo == 1 || this.user_data.privilegio[0].id_tipo == 2);
			} else {
				return false;
			}
		},

		goToAdmin() {
			if (location.hostname == "localhost") {
				window.open("http://localhost:8081/inicio/dashboard", "_blank");
			} else {
				window.open("https://linkiwork.com/administrador/inicio/dashboard", "_blank");
			}
		},

		updateUser() {
			this.user_data = this.$ls.get("user");	
		},
	
		//FF
		contactoShow() {
			this.$emit('eventContactoShow');
		},
		notificacionesShow() {
			this.$emit('eventNotificacionesShow');
		}
	}
};
</script>  

<template>
	<nav class="navbar-custom justify-content-between">
		<router-link to="/" class="ms-3">
			<img v-if="logoCliente" width="200" :src="logoCliente" class="d-block d-xl-block">
			<img v-else width="200" src="@/assets/img/intranet/header/logo-teamworkup.svg" class="d-block d-xl-block">
		</router-link> 
		<div class="d-flex">
			<div class="navbar-custom-menu border-end me-3 pe-3 d-none d-xxl-flex">
				<div v-for="header in menuCliente" :key="header.id_header" class="dropdown dropdown-custom">
					<template v-if="header.principal.length == 0">
						<a href="javascript:" class="dropdown-custom-nav" :style="{ 'color': header.color_activo }">
							<span class="dropdown-custom-nav-title">
								{{ header.nombre_header }}
							</span>
						</a>
					</template>
					<template v-else>
						<a 
							href="javascript:"
							class="dropdown-custom-nav"
							:style="{ 'color': header.color_activo }"
							data-bs-toggle="dropdown"
							data-bs-auto-close="outside"
						>
							<span class="dropdown-custom-nav-title">
								{{ header.nombre_header }}
							</span>
						</a>

						<ul class="dropdown-menu dropdown-custom-menu">
							<li 
								v-for="principalEl in header.principal" 
								:key="principalEl.id_elemento + principalEl.nombre_elemento"
								class="dropend dropdown-custom-menu-item"
							>
								<template v-if="principalEl.secundarios.length == 0">
									<a 
										class="dropdown-item dropdown-custom-menu-item-link"
										:href="sanitizeUrl(principalEl.url_externa)"
									>
										{{ principalEl.nombre_elemento }}
									</a>
								</template>
								<template v-else>					
									<a 
										class="dropdown-item dropdown-custom-menu-item-link d-flex justify-content-between align-items-center" 
										data-bs-toggle="dropdown" 
										data-bs-auto-close="outside"
										href="javascript:"
									>
										<span>{{ principalEl.nombre_elemento }}</span>
										<font-awesome-icon icon="fa-solid fa-angle-right" class="ps-3"></font-awesome-icon>
									</a>
									<ul class="dropdown-menu dropdown-custom-menu">
										<li
											v-for="secundarioEl in principalEl.secundarios" 
											:key="secundarioEl.id_elemento + secundarioEl.nombre_elemento"
											class="dropend dropdown-custom-menu-item"
										>
											<template v-if="secundarioEl.terciarios.length == 0">
												<a 
													class="dropdown-item dropdown-custom-menu-item-link"
													:href="sanitizeUrl(secundarioEl.url_externa)"
												>
													{{ secundarioEl.nombre_elemento }}
												</a>
											</template>
											<template v-else>	


												<a 
													class="dropdown-item dropdown-custom-menu-item-link d-flex justify-content-between align-items-center" 
													data-bs-toggle="dropdown" 
													data-bs-auto-close="outside"
													href="javascript:"
												>
													<span>{{ secundarioEl.nombre_elemento }}</span>
													<font-awesome-icon icon="fa-solid fa-angle-right" class="ps-3"></font-awesome-icon>
												</a>
												<ul class="dropdown-menu dropdown-custom-menu">
													<li
														v-for="terciarioEl in secundarioEl.terciarios" 
														:key="terciarioEl.id_elemento + terciarioEl.nombre_elemento"
														class="dropend dropdown-custom-menu-item"
													>
														<a 
															class="dropdown-item dropdown-custom-menu-item-link"
															:href="sanitizeUrl(terciarioEl.url_externa)"
														>
															{{ terciarioEl.nombre_elemento }}
														</a>
													</li>
												</ul>



											</template>

										</li>
									</ul>
								</template>
							</li>
						</ul>
					</template>
				</div>
			</div>
	
			<div class="navbar-custom-menu">		
				<a 
					@click="contactoShow()"
					href="javascript:" 
					class="navbar-custom-menu-btn position-relative me-3" 
				>
					<font-awesome-icon class="fa-light fa-address-book navbar-custom-menu-btn-icon" icon="fa-regular fa-address-book" ></font-awesome-icon>
					<!-- <span class="navbar-custom-menu-btn-circle bg-red border border-light rounded-circle"></span> -->
				</a>
				<a 
					@click="notificacionesShow()"
					href="javascript:" 
					class="navbar-custom-menu-btn position-relative me-3" 
				>
				<font-awesome-icon class="fa-light fa-bell navbar-custom-menu-btn-icon" icon="fa-regular fa-bell" ></font-awesome-icon>
				<!-- <span class="navbar-custom-menu-btn-circle bg-red border border-light rounded-circle"></span> -->
				</a>
				<div class="dropdown">
					<a 
						class="dropdown-toggle" 
						href="javascript:" 
						data-bs-toggle="dropdown"
						aria-expanded="false"
					>
					<div class="d-flex align-items-center navbar-custom-menu-user d-none d-md-flex">
						<div class="flex-grow-1 me-3 navbar-custom-menu-user-name">
							<p>
								¡Hola <strong>{{ user_data.primer_nombre }}!</strong>
							</p>
						</div>
						<div class="flex-shrink-0">
							<img 
								v-if="user_data.imagen_perfil"
								class="navbar-custom-menu-user-img"
								:src="user_data.imagen_perfil"
							>
							<img 
								v-if="!user_data.imagen_perfil"
								class="navbar-custom-menu-user-img"
								src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
							>
						</div>
					</div>
					</a>
	
					<ul class="dropdown-menu">
						<li v-if="checkUserStoragePrivilegio()">
							<a 
								@click="goToAdmin()"
								class="dropdown-item text-secondary" 
								href="javascript:">
								<font-awesome-icon icon="fa-solid fa-gear" class="color-main"></font-awesome-icon>
								Administrador
							</a>
						</li>
						<li>
							<router-link 
							to="/mi-perfil"
							class="dropdown-item text-secondary" 
							>
							<font-awesome-icon icon="fa-solid fa-circle-user" class="color-main"></font-awesome-icon>
							Mi perfil
							</router-link>
						</li>
						<li>
							<a
								class="dropdown-item text-secondary" 
								href="#"
								@click="logOut()"
							>
							<font-awesome-icon icon="fa-solid fa-right-from-bracket" class="color-main"></font-awesome-icon>
							Cerrar sesión
							</a>
						</li>
					</ul>
				</div>
			</div>	
		</div>
	</nav>
</template>